<div [style.padding]="padding + 'px'" class="row text-center">
  <div id="load-circle">
    <div class="loader"></div>
    <img class="logo-loading" src="assets/images/logo-loading.png" alt="" />
  </div>
</div>
